import { Button } from "primereact/button";
import 'primeicons/primeicons.css';
import plus from "../../assets/icons/plus.svg";
import { useCreateQuestionMutation, useGetSurveyQuery } from "../../redux/survey/survey.endpoints";
import { SurveyStatus } from "../../redux/survey/survey.types";
import SurveyService from "../../services/surveys/survey.service";
import { useDispatch } from "react-redux";
import { useEffect } from "react";
import { setSaveStateWithDelay } from "../../redux/survey/survey-status.utils";

interface AddQuestionBtnProps {
  expand?: boolean;
  extSurveyId: string;
}
const { Draft, Rejected } = SurveyStatus;

export const AddQuestionBtn = ({ expand = false, extSurveyId }: AddQuestionBtnProps) => {
  const isExpanded = expand ? 'p-4' : 'p-2';
  const dispatch = useDispatch();
  const { questionCount, canAddQuestion } = useGetSurveyQuery({ ext_survey_id: extSurveyId }, {
    selectFromResult: ({ data }) => {
      const canAdd = data?.surveyStatus === Draft || data?.surveyStatus === Rejected;
      const qCount = data?.questions?.length;

      return {
        questionCount: qCount,
        canAddQuestion: canAdd,
      };
    },
  });
  const [createQuestion, { isLoading: createLoading, isSuccess: createSuccess, error: createError }] = useCreateQuestionMutation();

  useEffect(() => {
    createError && console.error('Error creating question:', createError);
  }, [createError]);

  useEffect(() => {
    createSuccess && setSaveStateWithDelay(dispatch);
  }, [createSuccess]);

  const onClicked = () => {
    if (questionCount === undefined || createLoading || !canAddQuestion) {
      return;
    }
    void createQuestion(SurveyService.createQuestionData(extSurveyId, questionCount));
  };

  if (!canAddQuestion) {
    return null;
  }

  return (
    <Button
      type="button"
      onClick={onClicked}
      className={`mb-6 mt-2 flex w-full items-center rounded-lg border-2 border-dashed border-gray-201 text-black ${isExpanded}`}
    >
      <img
        className="mr-2 shrink-0 px-1"
        src={plus}
        alt="plus"
      />
      <div className="grow text-start text-gray-501">
        Add question
      </div>
    </Button>
  );
};
